import { render, staticRenderFns } from "./AdminProfiles.vue?vue&type=template&id=527c6fe2&scoped=true&"
import script from "./AdminProfiles.vue?vue&type=script&lang=js&"
export * from "./AdminProfiles.vue?vue&type=script&lang=js&"
import style0 from "./AdminProfiles.vue?vue&type=style&index=0&id=527c6fe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c6fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('527c6fe2')) {
      api.createRecord('527c6fe2', component.options)
    } else {
      api.reload('527c6fe2', component.options)
    }
    module.hot.accept("./AdminProfiles.vue?vue&type=template&id=527c6fe2&scoped=true&", function () {
      api.rerender('527c6fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminProfiles.vue"
export default component.exports